interface GateHausLogoProps {
  size?: number;
  stacked?: boolean;
}

const GateHausLogo = ({ size = 48, stacked = false }: GateHausLogoProps) => (
  <div className={stacked ? 'brand-logo stacked' : 'brand-logo'}>
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      role="img"
      aria-label="Gate.haus shield"
    >
      <defs>
        <linearGradient id="shieldGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#26b47f" />
          <stop offset="100%" stopColor="#1e9366" />
        </linearGradient>
      </defs>
      <path
        d="M32 4l22 8v18c0 13.2-9.4 24.6-22 28-12.6-3.4-22-14.8-22-28V12l22-8z"
        fill="url(#shieldGradient)"
        stroke="#1e9366"
        strokeWidth="2"
      />
      <path
        d="M32 16c-6.6 0-12 5.4-12 12h6c0-3.3 2.7-6 6-6s6 2.7 6 6-2.7 6-6 6a6 6 0 01-5.6-4h-6.4c0 6.6 5.4 12 12 12s12-5.4 12-12S38.6 16 32 16z"
        fill="#fff"
        opacity="0.85"
      />
    </svg>
    <div>
      <strong>gate.haus</strong>
    </div>
  </div>
);

export default GateHausLogo;
